import React from "react";
import Marque from "./Marque";
import "../styles/works.css";
import BigText from "./BigText";
import UberEats from "../images/uberss.png";
import TributePage from "../images/tributess.png";
import Todo from "../images/todoss.png";
import Calculator from "../images/calciss.png";
import InstaClone from "../images/instass.png";
import Vepa from "../images/vepass.png";
import OldPortfolio from "../images/oldportfoilio.jpeg";
import KhelMitra from "../images/khelmitra.jpeg";
import ProjeXFlow from "../images/projexflow.jpeg";
import BloodPlus from "../images/bloodplus.jpeg";
import Bodh from "../images/bodh.jpeg";
import BloodPlusApp from "../images/bloodplusapp.png";
import VakSahayaka from "../images/vaksahayaka.jpeg";
import Razorpay from "../images/razorpay.jpeg";
import Tilt from "./Tilt";
import GlowShade from "./GlowShade";

export default function Works() {
  return (
    <div className="works">
      <Marque id={"works"} text="Works" top="-100px" />
      <BigText text="WEB" align="right" />
      <GlowShade
        color="#00A86B"
        top="5%"
        left="-4%"
        height="200px"
        width="200px"
      />

      <Tilt
        image={Razorpay}
        height="200"
        alt="Razorpay Integration"
        date="02|25"
        link="https://razorpay-integration-demo.netlify.app/"
        left="65%"
        top="-120px"
        top2="-40px"
        left2="25%"
        height2="120"
      />

      <Tilt
        image={Bodh}
        height="200"
        alt="Bodh"
        date="02|24"
        link="https://bodh.netlify.app/"
        left="15%"
        top="-120px"
        left2="25%"
        height2="120"
      />

      <Tilt
        image={KhelMitra}
        height="200"
        alt="Khel Mitra"
        date="01|24"
        link="https://khelmitra.netlify.app/"
        left="60%"
        top="-160px"
        top2="40px"
        left2="25%"
        height2="120"
      />

      <Tilt
        image={BloodPlus}
        height="250"
        alt="Blood Plus"
        date="10|23"
        link="https://blood-plus.netlify.app/"
        left="10%"
        top="-100px"
        top2="80px"
        left2="25%"
        height2="147"
      />

      <GlowShade
        color="#824581"
        top="20%"
        left="80%"
        height="200px"
        width="200px"
        left2="50%"
      />

      <Tilt
        image={ProjeXFlow}
        height="600"
        alt="ProjeXFlow"
        date="09|23"
        link="https://projexflow.netlify.app/"
        left="65%"
        top="-180px"
        top2="120px"
        left2="30%"
        height2="400"
      />

      <Tilt
        image={OldPortfolio}
        height="500"
        alt="Old Portfolio"
        date="04|23"
        link="https://maheshcheegiti.github.io/cheegitimahesh/"
        left="20%"
        top="-450px"
        left2="30%"
        top2="160px"
        height2="300"
      />

      <GlowShade
        color="#1E90FFCC"
        top="40%"
        left="4%"
        height="200px"
        width="200px"
      />

      <Tilt
        image={UberEats}
        height="200"
        alt="Uber Eats"
        date="03|23"
        link="https://maheshcheegiti.github.io/ubereatsclone.com/"
        left="70%"
        top="-500px"
        top2="200px"
        left2="25%"
        height2="120"
      />

      <Tilt
        image={Todo}
        height="200"
        alt="Todo App"
        date="02|23"
        link="https://maheshcheegiti.github.io/oasisinfobyteinternship/TASK%203%20A%20BASIC%20TO-DO%20WEBAPP/index.html"
        left="10%"
        top="-450px"
        left2="25%"
        top2="240px"
        height2="120"
      />
      <Tilt
        image={TributePage}
        height="200"
        alt="Tribute Page"
        date="02|23"
        link="https://maheshcheegiti.github.io/oasisinfobyteinternship/TASK%202%20TRIBUTE%20PAGE/index.html"
        left="65%"
        top="-500px"
        left2="25%"
        top2="280px"
        height2="120"
      />
      <Tilt
        image={Calculator}
        height="200"
        alt="Calculator"
        date="02|23"
        link="https://maheshcheegiti.github.io/oasisinfobyteinternship/TASK%201%20CALCULATOR/index.html"
        left="15%"
        top="-450px"
        left2="25%"
        top2="320px"
        height2="120"
      />

      <GlowShade
        color="#FF450099"
        top="60%"
        left="80%"
        height="200px"
        width="200px"
        left2="50%"
      />

      <Tilt
        image={InstaClone}
        height="200"
        alt="Insta Clone"
        date="01|23"
        link="https://maheshcheegiti.github.io/Instagram-Clone/"
        left="65%"
        top="-350px"
        left2="25%"
        top2="360px"
        height2="120"
      />
      <Tilt
        image={Vepa}
        height="200"
        alt="Vepa"
        date="10|22"
        link="https://maheshcheegiti.github.io/vepa.com/"
        left="20%"
        top="-400px"
        left2="25%"
        top2="400px"
        height2="120"
      />
      <BigText text="MOBILE" align="left" top="-400px" top2="440px" />

      <Tilt
        image={BloodPlusApp}
        height="400"
        alt="Blood Plus App"
        date="11|23"
        link="https://www.figma.com/proto/UUipgWOCeypq0yv2kjZ9Ck/Blood-Plus-App-Figma-Templates?type=design&node-id=20-138&t=KfZkMS2n2ePOUYrs-1&scaling=scale-down&page-id=0%3A1&starting-point-node-id=20%3A138&mode=design"
        left="65%"
        top="-500px"
        left2="30%"
        top2="480px"
        height2="300"
      />

      <GlowShade
        color="#00A86B"
        top="80%"
        left="4%"
        height="200px"
        width="200px"
      />

      <BigText text="ChatBots" align="right" top="-500px" top2="530px" />
      <Tilt
        image={VakSahayaka}
        height="200"
        alt="Vak Sahayaka"
        date="07|23"
        link="https://www.youtube.com/watch?v=LsSd-n-aeWE"
        left="15%"
        top="-500px"
        left2="25%"
        top2="560px"
        height2="120"
      />
    </div>
  );
}
